var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buyer"},[_c('div',{staticClass:"container buyer-container"},[_vm._m(0),_c('div',{staticClass:"buyer-content d-flex justify-content-center"},[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proship-logo-wrapper text-center"},[_c('img',{staticClass:"proship-logo",attrs:{"src":require("@/assets/images/shared/proship-logo-sm.png"),"alt":""}})])
}]

export { render, staticRenderFns }